<div class="d-flex w-100">
  <div
    class="rating"
    [ngClass]="{ 'gmr-16 gmr-md-24': !last }"
    *ngFor="let percent of percents; let last = last"
  >
    <div class="rating-wrapper rating-upper" [style.width]="percent">
      <svg
        *ngIf="!male"
        width="16.45"
        height="43.4"
        viewBox="0 0 24 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.94 16.5161C16.4931 16.5161 20.1841 12.8189 20.1841 8.25806C20.1841 3.69726 16.4931 0 11.94 0C7.38692 0 3.69592 3.69726 3.69592 8.25806C3.69592 12.8189 7.38692 16.5161 11.94 16.5161ZM3.31438 22.6717C3.57137 20.6767 5.27002 19.1828 7.2816 19.1828H9.88245L12.0079 21.1828L14.1333 19.1828H16.7341C18.7457 19.1828 20.4444 20.6767 20.7014 22.6717L23.7929 46.6717C24.101 49.064 22.2377 51.1828 19.8257 51.1828H16.6692L15.8614 60.407C15.6834 62.4401 13.9809 64 11.94 64C9.89905 64 8.19661 62.4401 8.01856 60.407L7.2108 51.1828H4.19008C1.77806 51.1828 -0.0853 49.064 0.222854 46.6717L3.31438 22.6717Z"
          [attr.fill]="color"
        />
      </svg>
      <svg
        *ngIf="male"
        width="16.45"
        height="43.4"
        viewBox="0 0 25 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4879 8.25806C20.4879 12.8189 16.8438 16.5161 12.3485 16.5161C7.85321 16.5161 4.20907 12.8189 4.20907 8.25806C4.20907 3.69726 7.85321 0 12.3485 0C16.8438 0 20.4879 3.69726 20.4879 8.25806ZM0.40079 22.8266C0.259012 20.5251 2.08735 18.5807 4.39322 18.5807H10.3135L12.3483 22.7097L14.3832 18.5807H20.3035C22.6093 18.5807 24.4377 20.5251 24.2959 22.8266L23.2626 39.6008C23.1326 41.7105 21.3838 43.3549 19.2701 43.3549H17.8469L16.6765 60.276C16.5315 62.373 14.7881 64 12.686 64H12.0124C9.91041 64 8.16701 62.373 8.02197 60.276L6.85159 43.3549H5.42655C3.31292 43.3549 1.56407 41.7105 1.43411 39.6008L0.40079 22.8266Z"
          [attr.fill]="color"
        />
      </svg>
    </div>
    <div class="rating-wrapper rating-lower">
      <svg
        *ngIf="!male"
        width="16.45"
        height="43.4"
        viewBox="0 0 24 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.94 16.5161C16.4931 16.5161 20.1841 12.8189 20.1841 8.25806C20.1841 3.69726 16.4931 0 11.94 0C7.38692 0 3.69592 3.69726 3.69592 8.25806C3.69592 12.8189 7.38692 16.5161 11.94 16.5161ZM3.31438 22.6717C3.57137 20.6767 5.27002 19.1828 7.2816 19.1828H9.88245L12.0079 21.1828L14.1333 19.1828H16.7341C18.7457 19.1828 20.4444 20.6767 20.7014 22.6717L23.7929 46.6717C24.101 49.064 22.2377 51.1828 19.8257 51.1828H16.6692L15.8614 60.407C15.6834 62.4401 13.9809 64 11.94 64C9.89905 64 8.19661 62.4401 8.01856 60.407L7.2108 51.1828H4.19008C1.77806 51.1828 -0.0853 49.064 0.222854 46.6717L3.31438 22.6717Z"
          fill="#EFEFF4"
        />
      </svg>
      <svg
        *ngIf="male"
        width="16.45"
        height="43.4"
        viewBox="0 0 25 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4879 8.25806C20.4879 12.8189 16.8438 16.5161 12.3485 16.5161C7.85321 16.5161 4.20907 12.8189 4.20907 8.25806C4.20907 3.69726 7.85321 0 12.3485 0C16.8438 0 20.4879 3.69726 20.4879 8.25806ZM0.40079 22.8266C0.259012 20.5251 2.08735 18.5807 4.39322 18.5807H10.3135L12.3483 22.7097L14.3832 18.5807H20.3035C22.6093 18.5807 24.4377 20.5251 24.2959 22.8266L23.2626 39.6008C23.1326 41.7105 21.3838 43.3549 19.2701 43.3549H17.8469L16.6765 60.276C16.5315 62.373 14.7881 64 12.686 64H12.0124C9.91041 64 8.16701 62.373 8.02197 60.276L6.85159 43.3549H5.42655C3.31292 43.3549 1.56407 41.7105 1.43411 39.6008L0.40079 22.8266Z"
          fill="#EFEFF4"
        />
      </svg>
    </div>
  </div>
</div>
